import React from 'react'

import { Fieldset, Input, PriceString } from '@fourthwall/components'

import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'
import * as S from './styled'

export const YearDiscount = () => {
  const { form, annualDiscount, isLoading } = useTierContext()

  if (form.values.discountType !== 'oneTime') return null
  if (form.values.price && parseFloat(form.values.price) === 0) return null
  if (!form.values.discount || !annualDiscount) return null

  const renderYearDiscountInfo = () => {
    if (
      !form.values.price ||
      !form.values.yearDiscount ||
      parseInt(form.values.yearDiscount) > 100 ||
      parseInt(form.values.yearDiscount) < 0 ||
      !annualDiscount
    )
      return null

    const yearPrice = form.values.price
      ? parseFloat(form.values.price) * 12 -
        parseFloat(form.values.price) * 12 * (annualDiscount / 100)
      : 0

    return (
      <S.DiscountInfo>
        <S.DiscountInfoLabel>First year</S.DiscountInfoLabel>
        {/* <PriceString value={yearPrice - yearPrice * (parseInt(form.values.yearDiscount) / 100)} /> */}
        <PriceString
          value={
            Math.floor((yearPrice - yearPrice * (parseInt(form.values.yearDiscount) / 100)) * 100) /
            100
          }
        />
      </S.DiscountInfo>
    )
  }

  return (
    <Fieldset.Row inner>
      <S.Container>
        <S.DisountLabel>Annual membership</S.DisountLabel>
        <S.DiscountInputContainer>
          <Input
            label="First year discount"
            type="number"
            append="%"
            hideSpinner
            disabled={isLoading}
            {...form.getFieldProps(FormFields.yearDiscount)}
          />
          {renderYearDiscountInfo()}
        </S.DiscountInputContainer>
      </S.Container>
    </Fieldset.Row>
  )
}
